import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { BACKEND_URL } from "./lib/api";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import ArticlePage from "./pages/ArticlePage";
import SearchPage from "./pages/SearchPage";
import SpendingChecker from "./pages/SpendingChecker";
import AuthorPage from "./pages/AuthorPage";
import NotFound from "./pages/NotFound";
import { StaticPage, ContactPage } from "./pages/StaticPages";
import { AuthProvider, RequireAuth } from "./admin/AuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import ArticleList from "./admin/ArticleList";
import ArticleEditor from "./admin/ArticleEditor";
import CsvImport from "./admin/CsvImport";
import Tokens, { Subscribers } from "./admin/Tokens";

const STATIC = ["about", "privacy", "terms", "editorial-policy", "affiliate-disclosure", "advertising-disclosure"];

const ExternalRedirect = ({ to }) => { useEffect(() => { window.location.replace(to); }, [to]); return null; };

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
              <Route index element={<Dashboard />} />
              <Route path="articles" element={<ArticleList />} />
              <Route path="articles/new" element={<ArticleEditor />} />
              <Route path="articles/:id" element={<ArticleEditor />} />
              <Route path="import" element={<CsvImport />} />
              <Route path="tokens" element={<Tokens />} />
              <Route path="subscribers" element={<Subscribers />} />
            </Route>
            <Route path="/admin/preview/:id" element={<RequireAuth><Layout /></RequireAuth>}>
              <Route index element={<ArticlePage preview />} />
            </Route>
            <Route path="/sitemap.xml" element={<ExternalRedirect to={`${BACKEND_URL}/api/sitemap.xml`} />} />
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/tools/everyday-spending-checker" element={<SpendingChecker />} />
              <Route path="/author/:slug" element={<AuthorPage />} />
              <Route path="/contact" element={<ContactPage />} />
              {STATIC.map((s) => <Route key={s} path={`/${s}`} element={<StaticPage slug={s} />} />)}
              <Route path="/:categorySlug" element={<CategoryPage />} />
              <Route path="/:categorySlug/:slug" element={<ArticlePage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
